/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Sales
 * Это Sales api сервер, для запросов от Frontend.  Для запросов требуется указать header с Authorization и типом Bearer.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { ResponseEnterpriseGetListMeta } from './ResponseEnterpriseGetListMeta'
import {
  ResponseEnterpriseGetListMetaFromJSON,
  ResponseEnterpriseGetListMetaFromJSONTyped,
  ResponseEnterpriseGetListMetaToJSON,
  ResponseEnterpriseGetListMetaToJSONTyped,
} from './ResponseEnterpriseGetListMeta'
import type { SaleItem } from './SaleItem'
import {
  SaleItemFromJSON,
  SaleItemFromJSONTyped,
  SaleItemToJSON,
  SaleItemToJSONTyped,
} from './SaleItem'

/**
 *
 * @export
 * @interface ResponseSaleItemsGetList
 */
export interface ResponseSaleItemsGetList {
  /**
   *
   * @type {boolean}
   * @memberof ResponseSaleItemsGetList
   */
  success: boolean
  /**
   *
   * @type {Array<SaleItem>}
   * @memberof ResponseSaleItemsGetList
   */
  data?: Array<SaleItem>
  /**
   *
   * @type {ResponseEnterpriseGetListMeta}
   * @memberof ResponseSaleItemsGetList
   */
  meta?: ResponseEnterpriseGetListMeta
  /**
   *
   * @type {string}
   * @memberof ResponseSaleItemsGetList
   */
  errorMessage?: string
  /**
   *
   * @type {number}
   * @memberof ResponseSaleItemsGetList
   */
  codeError?: number
}

/**
 * Check if a given object implements the ResponseSaleItemsGetList interface.
 */
export function instanceOfResponseSaleItemsGetList(
  value: object,
): value is ResponseSaleItemsGetList {
  if (!('success' in value) || value['success'] === undefined) return false
  return true
}

export function ResponseSaleItemsGetListFromJSON(
  json: any,
): ResponseSaleItemsGetList {
  return ResponseSaleItemsGetListFromJSONTyped(json, false)
}

export function ResponseSaleItemsGetListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ResponseSaleItemsGetList {
  if (json == null) {
    return json
  }
  return {
    success: json['success'],
    data:
      json['data'] == null
        ? undefined
        : (json['data'] as Array<any>).map(SaleItemFromJSON),
    meta:
      json['meta'] == null
        ? undefined
        : ResponseEnterpriseGetListMetaFromJSON(json['meta']),
    errorMessage:
      json['errorMessage'] == null ? undefined : json['errorMessage'],
    codeError: json['codeError'] == null ? undefined : json['codeError'],
  }
}

export function ResponseSaleItemsGetListToJSON(
  json: any,
): ResponseSaleItemsGetList {
  return ResponseSaleItemsGetListToJSONTyped(json, false)
}

export function ResponseSaleItemsGetListToJSONTyped(
  value?: ResponseSaleItemsGetList | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value
  }

  return {
    success: value['success'],
    data:
      value['data'] == null
        ? undefined
        : (value['data'] as Array<any>).map(SaleItemToJSON),
    meta: ResponseEnterpriseGetListMetaToJSON(value['meta']),
    errorMessage: value['errorMessage'],
    codeError: value['codeError'],
  }
}
